import {
  Box,
  Container,
  Paper,
  Typography,
  Stack,
  Button,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ThemeProvider } from '@mui/material/styles';
import legalInsightsDarkTheme from '../../LegalInsightsDarkTheme';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={legalInsightsDarkTheme}>
      <Box
        sx={{
          backgroundImage: `url("/newsletter.jpg")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Container maxWidth='lg' disableGutters sx={{ paddingX: 2 }}>
          <Paper
            elevation={0}
            marginY={6}
            component={Stack}
            direction='column'
            useFlexGap
            spacing={2}
            padding={6}
            sx={{ width: { xs: '100%', lg: '50%' } }}
          >
            <Typography variant='h2'>{t('newsletterSection.title')}</Typography>
            <Typography
              variant='body1'
              sx={{
                marginBottom: 2,
              }}
            >
              {t('newsletterSection.description')}
            </Typography>
            <Box>
              <Button
                // Do not change the ID! It is used in GTM & Google Analytics to track clicks on this link.
                id='JA_newsletter_cta'
                variant='contained'
                size='large'
                href='https://www.almainsights.fi/tietoa-meista/uutiskirjeet/tilaa-juridiikan-ja-talouden-uutiskirje/'
                sx={{
                  textTransform: 'none',
                  width: { xs: '100%', sm: 'auto' },
                }}
                endIcon={<ArrowForwardIcon />}
              >
                {t('newsletterSection.cta')}
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
